import { applyMiddleware, createStore, compose } from 'redux';
import reducers from '../reducers';
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware';
import createHistory from 'history/createBrowserHistory'

const composeEnhancers = 
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?   
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose

const enhancer = composeEnhancers(
  applyMiddleware(thunk, promise())
  )

const store = createStore(
  reducers,
  enhancer
  );

export const history = createHistory()

export default store




// WEBPACK FOOTER //
// ./src/store/store.js